import React from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

const forgotPasswordSchema = yup.object().shape({
  email: yup.string().email("Invalid email").required("Email is required"),
});

const ForgotPasswordForm = ({ onSubmit, switchToLogin }) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(forgotPasswordSchema),
  });

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="auth-form">
      <div className="form-field">
        <input type="email" placeholder="Email" {...register("email")} />
        {errors.email && <p className="error">{errors.email.message}</p>}
      </div>
      <button type="submit" className="submit-button">
        Send Reset Link
      </button>
      <div className="auth-footer">
        <a onClick={switchToLogin} className="login-link">
          Back to Login
        </a>
      </div>
    </form>
  );
};

export default ForgotPasswordForm;
